var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6.85714,
    fill: "#0CBD2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7614 8.33398C16.2567 8.33401 12.8955 9.49365 10.4173 11.5578C7.93914 13.622 6.5469 16.4216 6.54688 19.3408C6.55007 21.2395 7.14293 23.1053 8.26785 24.7568C9.39276 26.4083 11.0115 27.7893 12.9667 28.7657C12.4459 29.9315 11.6649 31.0247 10.656 32C12.6125 31.6566 14.4492 30.935 16.023 29.8916C17.2364 30.1919 18.4954 30.3455 19.7614 30.3475C23.2661 30.3475 26.6272 29.1879 29.1054 27.1237C31.5836 25.0595 32.9758 22.2599 32.9759 19.3408C32.9758 16.4216 31.5836 13.622 29.1054 11.5578C26.6272 9.49365 23.2661 8.33401 19.7614 8.33398Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImessage);
export default __webpack_public_path__ + "static/media/imessage.d97ac2127c0e2b8c54c97040a4e4544c.svg";
export { ForwardRef as ReactComponent };